import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/layout/Header";
import { useApp } from "../context/AppContext";

// ─── Footer ───────────────────────────────────────────────────────────────────
function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="main-footer">
            <span>© {year} Taranaz Digital Solutions. All Rights Reserved.</span>
            <span className="footer-divider">·</span>
            <span><strong>Support:</strong> Email: farooqueparvez@gmail.com - Mobile: +91 9021465049 </span>
        </footer>
    );
}

// ─── AdminLayout ──────────────────────────────────────────────────────────────
export default function AdminLayout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const { user, selectedCollegeId, selectCollege } = useApp();

    // Close sidebar on every route change (for mobile)
    useEffect(() => {
        setSidebarOpen(false);
    }, [location.pathname]);

    // Sync active college context from URL query param for superadmin
    useEffect(() => {
        if (user?.role === "superadmin") {
            const searchParams = new URLSearchParams(location.search);
            const collegeParam = searchParams.get("college");
            if (collegeParam && collegeParam !== selectedCollegeId) {
                selectCollege(collegeParam);
            }
        }
    }, [location.search, user, selectedCollegeId, selectCollege]);

    return (
        <div className="app-layout">
            {/* Mobile overlay — click to close sidebar */}
            {sidebarOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <Sidebar className={sidebarOpen ? "open" : ""} />

            {/* Content wrapper: header + main + footer */}
            <div className="content-wrapper">
                <Header onMenuToggle={() => setSidebarOpen((p) => !p)} />
                <main className="main-content">
                    {children}
                </main>
                <Footer />
            </div>
        </div>
    );
}